<template>
  <Transition name="toast">
    <div 
      v-if="visible" 
      :class="['toast-notification', `toast-${type}`]"
      @mouseenter="pauseTimer"
      @mouseleave="resumeTimer"
    >
      <div class="toast-content">
        <i :class="iconClass"></i>
        <span class="toast-message">{{ message }}</span>
        <button 
          v-if="closable" 
          class="toast-close" 
          @click="close"
          aria-label="Close"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
    },
    duration: {
      type: Number,
      default: 4000
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    };
  },
  computed: {
    iconClass() {
      const icons = {
        success: 'bi bi-check-circle-fill',
        error: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      };
      return icons[this.type] || icons.info;
    }
  },
  mounted() {
    this.show();
  },
  beforeUnmount() {
    this.clearTimer();
  },
  methods: {
    show() {
      this.visible = true;
      if (this.duration > 0) {
        this.startTimer();
      }
    },
    close() {
      this.clearTimer();
      this.visible = false;
      // Emit close event after animation completes
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    startTimer() {
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.close();
      }, this.duration);
    },
    pauseTimer() {
      this.clearTimer();
    },
    resumeTimer() {
      if (this.duration > 0) {
        this.startTimer();
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style src="./styles/Toast.css"></style>

